import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { LETTERS_FORM_NAME, InputMode } from 'Common/FormEnum';
import React, { Component, Fragment } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { TitledCard } from 'Components/';
import moment from 'moment';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { LettersFieldEnum as Fields } from 'Common/FieldEnum';
import {
  DatePickerField,
  SelectField,
  InputField,
} from 'Common/SemanticWrapper';
import { Grid } from 'semantic-ui-react';
import CheckboxListComponent from 'Common/CheckboxListComponent';
import { SiteComponent } from 'Common/SiteComponent';
import { isPreferenceDisabled } from 'Common/Security/SecurityHelpers';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { isNumeric } from 'Common/GeneralHelper';
import { formatDecimal } from 'Common/FormHelper';

class LettersFormContainer extends Component {
  componentDidMount() {
    this.props.onEmailSubmit(this.props.submit);
  }

  renderBalanceInputs = () => {
    const { formValues } = this.props;

    if (formValues[Fields.LetterType] !== 2) {
      return (
        <Grid.Column computer={4} tablet={8} mobile={8}>
          <Grid className={'segment'} style={{ minWidth: '300px' }}>
            <Grid.Row>
              <Grid.Column computer={12} tablet={10} mobile={10}>
                <Field
                  style={{ width: '100%' }}
                  label={'Owes more than:'}
                  component={InputField}
                  mode={InputMode.Decimal}
                  name={Fields.Balance1}
                  formatOnBlur={formatDecimal(2)}
                  maxLength={6}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      );
    }

    return (
      <Grid.Column tablet={12} computer={8}>
        <Grid className={'segment'}>
          <Grid.Row>
            <Grid.Column
              computer={4}
              style={{ display: 'table', height: '100%' }}
            >
              <div
                style={{
                  verticalAlign: 'middle',
                  display: 'table-cell',
                }}
              >
                <label>Balance between:</label>
              </div>
            </Grid.Column>
            <Grid.Column computer={4}>
              <Field
                style={{ width: '100%' }}
                label={''}
                component={InputField}
                mode={InputMode.Decimal}
                name={Fields.Balance1}
                formatOnBlur={formatDecimal(2)}
                maxLength={6}
              />
            </Grid.Column>

            <Grid.Column
              computer={3}
              style={{ display: 'table', height: '100%' }}
            >
              <div
                style={{
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  display: 'table-cell',
                }}
              >
                <label> And</label>
              </div>
            </Grid.Column>
            <Grid.Column computer={4}>
              <Field
                style={{ width: '100%' }}
                label={''}
                component={InputField}
                mode={InputMode.Decimal}
                name={Fields.Balance2}
                formatOnBlur={formatDecimal(2)}
                maxLength={6}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    );
  };

  render() {
    const { grades } = this.props;

    const gradeOptions = (grades && grades.length > 1
      ? [{ value: 'ALL', key: -1, text: 'ALL' }]
      : []
    ).concat(
      grades
        ? grades.map((grade, i) => ({
            value: grade.Id,
            key: i,
            text: `${grade.Id}   ${grade.Description}`,
          }))
        : []
    );

    return (
      <Fragment>
        <TitledCard>
          <Grid>
            <Grid.Row>
              <Grid.Column width={4}>
                <Field
                  label={'Date of Letter:'}
                  name={Fields.LetterDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={moment()}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <ReduxFormButtonGroup
                  label={'Print Type:'}
                  options={[
                    { value: 0, label: 'Letter' },
                    { value: 1, label: 'Email' },
                  ]}
                  formName={LETTERS_FORM_NAME}
                  value={0}
                  fieldName={Fields.PrintType}
                  disabled={isPreferenceDisabled(
                    PrefEnum.AllowEmailLetters,
                    this.props.security.preferences
                  )}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column mobile={12} tablet={12} computer={7}>
                <ReduxFormButtonGroup
                  label={'Letter Type:'}
                  options={[
                    { value: 0, label: 'Student Bill' },
                    { value: 1, label: 'Teacher Bill' },
                    { value: 2, label: 'Low Balance' },
                  ]}
                  formName={LETTERS_FORM_NAME}
                  value={0}
                  fieldName={Fields.LetterType}
                />
              </Grid.Column>
              {this.renderBalanceInputs()}
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={5}>
                <Field
                  style={{ width: '100%' }}
                  name={Fields.SortByType}
                  component={SelectField}
                  type="text"
                  label="Sort By:"
                  options={[
                    { value: 0, key: 0, text: 'Last Name, First Name' },
                    {
                      value: 1,
                      key: 1,
                      text: 'Site ID, Teacher',
                    },
                  ]}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <TitledCard title="Filter By">
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <SiteComponent
                  style={{ width: '100%' }}
                  name={Fields.SiteId}
                  isForm={true}
                  isPrimary={false}
                  className={'shorter'}
                />
              </Grid.Column>
              <Grid.Column width={5}>
                <Field
                  style={{ width: '100%' }}
                  name={Fields.GradeId}
                  component={SelectField}
                  type="text"
                  label="Grade"
                  options={gradeOptions}
                  className={'shorter'}
                  disabled={false}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column className="field">
                <div>
                  <label className={'p-b-0'}>Meal Status:</label>
                </div>
                <Grid
                  className={'segment'}
                  style={{
                    background: '#F9F9F9',
                    paddingTop: '5px',
                    minWidth: '740px',
                  }}
                >
                  <CheckboxListComponent
                    {...this.props}
                    title={''}
                    showAll={true}
                    displayItems={this.props.statusCheckboxes}
                  />
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Fragment>
    );
  }
}

const validate = (values) => {
  var errors = [];

  if (!moment(values[Fields.LetterDate], 'MM/DD/YYYY').isValid()) {
    errors[Fields.LetterDate] = 'Letter date is required.';
  } else {
    if (
      moment(values[Fields.LetterDate], 'MM/DD/YYYY').inspect() ===
        'invalid date' ||
      !moment(moment(values[Fields.LetterDate])).isAfter('1980-01-01')
    ) {
      errors[Fields.LetterDate] = 'Letter date is invalid.';
    }
  }

  var isValidBalance1 = isNumeric(parseFloat(values[Fields.Balance1]));

  if (!isValidBalance1) {
    errors[Fields.Balance1] = 'Invalid';
  }

  if (values[Fields.LetterType] !== 2) {
    if (isValidBalance1 && values[Fields.Balance1] <= 0) {
      errors[Fields.Balance1] = '# greater than zero.';
    }
  } else {
    //LowBalance
    if (!isNumeric(parseFloat(values[Fields.Balance2]))) {
      errors[Fields.Balance2] = 'Invalid';
    } else {
      if (
        isValidBalance1 &&
        parseFloat(values[Fields.Balance2]) <
          parseFloat(values[Fields.Balance1])
      ) {
        errors[Fields.Balance2] = 'Invalid';
      }

      if (parseFloat(values[Fields.Balance2]) <= 0) {
        errors[Fields.Balance2] = '# > than zero.';
      }
    }
  }

  return errors;
};

const mapStateToProps = (state) => {
  return {
    formValues: getFormValues(LETTERS_FORM_NAME)(state),
    grades: state.LettersState.report.grades,
    security: state.SecurityState,
  };
};

const LettersForm = reduxForm({
  form: LETTERS_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(connect(mapStateToProps, {})(LettersFormContainer)));

export { LettersForm };



// WEBPACK FOOTER //
// ./src/pages/letters/components/LettersForm.js